import { CurrencyCode } from '@payflip/utils';
import { Icon, IconName } from '../../medias';
import { NumberInput, NumberInputProps } from '../number-input/number-input';

export const currencySymbolMap: Record<CurrencyCode, JSX.Element> = {
  EUR: <Icon w="16px" h="16px" name={IconName.Euro} data-testid="icon-euro" />
};

export type CurrencyInputProps = NumberInputProps & { currency?: CurrencyCode };

export function CurrencyInput({
  currency = 'EUR',
  ...rest
}: CurrencyInputProps): JSX.Element {
  return <NumberInput leftElement={currencySymbolMap[currency]} {...rest} />;
}
